import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';

import { makeGetSortedActiveProjectMilestones } from '../selectors/milestones';
import { makeGetFetchedState, makeGetLoadingState } from '../selectors/global';

import { fetchMilestones } from '../actions/milestones';
import { showModal } from '../actions/modal';

import Popout from './popout';
import MilestoneName from './milestone-name';
import CanUser from './can-user';
import FieldDefault from './field-default';

import IconClose from '../icons/icon-close';

class SelectMilestonePopout extends PureComponent {
    static defaultProps = {
        excluded: [],
        removeCopy: 'Remove Milestone'
    }
    state = {
        popoutVisible: false,
        searchTerm: ''
    };

    handlePopoutOpenClick = () => {
        this.show();
    }

    handlePopoutCloseClick = () => {
        this.hide();
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
    }

    handleMilestoneRemove = () => {
        this.props.onRemove && this.props.onRemove();

        this.hide();
    }

    handleMilestoneSelect(milestone) {
        this.props.onSelect(milestone);

        this.hide();
    }

    handleCreateMilestoneClick = () => {
        showModal('MILESTONE_CREATE', {
            milestoneProps: {
                project: this.props.projectId
            },
            milestones: this.props.milestones,
            onCreate: id => {
                this.props.onSelect({ id });
            }
        });

        this.hide();
    }

    handleSearchChange = searchTerm => {
        this.setState({ searchTerm });
    }

    show() {
        this.popoutCtrl && this.popoutCtrl.show();
        this.attemptFetch();
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    attemptFetch() {
        if (!this.props.fetched && !this.props.loading) {
            fetchMilestones(this.props.projectId);
        }
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;

    render() {
        const milestones = this.state.searchTerm ? this.props.milestones.filter(milestone => (milestone.name || '').toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) > -1) : this.props.milestones;

        // TODO: Add content loader
        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                className: child.props.className + (this.state.popoutVisible ? ' selected disable-tooltip' : ''),
                onClick: this.handlePopoutOpenClick
            });
        });

        return (
            <React.Fragment>
                { children }

                <Popout
                    className="no-arrow xxsmall"
                    provideController={this.setPopoutCtrl}
                    onShow={this.handlePopoutShow}
                    onHide={this.handlePopoutHide}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    closeOnEveryClick={true}
                >
                    <div className="popout-head">
                        {this.props.title}

                        <button className="btn btn-icon btn-small popout-close" onClick={this.handlePopoutCloseClick}>
                            <IconClose />
                        </button>
                    </div>

                    <div className="popout-main">
                        <div className="resource-selector nice-scroll">
                            <FieldDefault
                                small={true}
                                placeholder="Search milestones…"
                                value={this.state.searchTerm}
                                autoFocus={true}
                                onChange={this.handleSearchChange}
                            />

                            {
                                milestones.length ? 
                                    milestones.sort((a, b) => a.order - b.order).map(milestone => (
                                        <div className={'item' + (this.props.selected === milestone.id ? ' selected' : '')} key={milestone.id}>
                                            <div className="item-inner" onClick={this.handleMilestoneSelect.bind(this, milestone)}>
                                                <div className="item-body">
                                                    <h5>{milestone.name || (milestone.id && <MilestoneName id={milestone.id} />)}</h5>

                                                    <h6>
                                                        {
                                                            new Date(milestone.start).getMonth() === 4 ? (
                                                                <Moment format="MMM DD">{milestone.start}</Moment>
                                                            ) : (
                                                                <Moment format="MMM. DD">{milestone.start}</Moment>
                                                            )
                                                        }
                                                        &nbsp;-&nbsp;
                                                        {
                                                            new Date(milestone.end).getMonth() === 4 ? (
                                                                <Moment format="MMM DD">{milestone.end}</Moment>
                                                            ) : (
                                                                <Moment format="MMM. DD">{milestone.end}</Moment>
                                                            )
                                                        }
                                                    </h6>
                                                </div>

                                                <div className="item-marker">
                                                    <i className="ion ion-checkmark" />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                :
                                <p className="no-resources">
                                    No Milestones available.

                                    {
                                        this.props.showCreate ? (
                                            <CanUser type="createMilestone">&nbsp;<button className="btn btn-link btn-colored" onClick={this.handleCreateMilestoneClick}>Create a Milestone</button></CanUser>
                                        ) : null
                                    }
                                </p>
                            }
                        </div>
                    </div>

                    {
                        this.props.selected ? (
                            <div className="popout-foot">
                                <span className="action" onClick={this.handleMilestoneRemove}>{this.props.removeCopy}</span>
                            </div>
                        ) : null
                    }
                </Popout>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getSortedActiveProjectMilestones = makeGetSortedActiveProjectMilestones();
    const getMilestonesFetched = makeGetFetchedState();
    const getMilestonesLoading = makeGetLoadingState();

    return ({ users, milestones }, ownProps) => ({
        milestones: getSortedActiveProjectMilestones(milestones.items, ownProps.projectId, ownProps.excluded),
        loading: getMilestonesLoading(milestones.fetchInfo, 'project', ownProps.projectId),
        fetched: getMilestonesFetched(milestones.fetchInfo, 'project', ownProps.projectId)
    });
}

export default connect(makeMapStateToProps)(SelectMilestonePopout);
